module.exports = __webpack_public_path__ + "img/solution.125a2ddd.svg";